// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--SM+v2";
export var heading1 = "heading-module--heading1--pZY38 heading-module--heading--SM+v2";
export var heading2 = "heading-module--heading2--rvNNU heading-module--heading--SM+v2";
export var heading3 = "heading-module--heading3--OjZcL heading-module--heading--SM+v2";